/**
 * ZKNL productpagina-gedrag (Task 12): sticky mobiele add-to-cart + optionele
 * add-ons die met de hoofd-ATC meegaan via Cart AJAX.
 *
 * Bewust GEEN afhankelijkheid van zknl-motion.js (dat bestand is van een
 * andere parallelle taak) en geen wijzigingen aan Dawn's eigen
 * product-form.js / cart-drawer.js — alleen progressive enhancement er
 * bovenop, met een harde no-JS fallback voor add-ons (losse formulieren)
 * en voor de urgentieregel (die server-side al gewoon tekst toont).
 */
(function () {
  'use strict';

  // Markeer dat JS actief is zodat de add-ons-checkboxes (die zonder JS niets
  // doen) pas zichtbaar worden — zie .zknl-js regels in zknl-product.css.
  document.documentElement.classList.add('zknl-js');

  var PRODUCT_FORM_SELECTOR = 'form[data-type="add-to-cart-form"]';

  function getMainProductForm() {
    return document.querySelector(PRODUCT_FORM_SELECTOR);
  }

  /* ------------------------------------------------------------------ *
   * Sticky add-to-cart bar
   * ------------------------------------------------------------------ */
  if (!customElements.get('zknl-sticky-atc')) {
    customElements.define(
      'zknl-sticky-atc',
      class ZknlStickyAtc extends HTMLElement {
        connectedCallback() {
          this.button = this.querySelector('[data-zknl-sticky-submit]');
          if (this.button) {
            this.button.addEventListener('click', this.onSubmitClick.bind(this));
          }

          this.buybox = document.querySelector('.zknl-product__buybox');
          if (!this.buybox || !('IntersectionObserver' in window)) return;

          this.observer = new IntersectionObserver(this.onIntersect.bind(this), {
            root: null,
            threshold: 0,
          });
          this.observer.observe(this.buybox);
        }

        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
        }

        onIntersect(entries) {
          var entry = entries[entries.length - 1];
          // Only reveal once the buy-box has scrolled *above* the viewport —
          // never while the page hasn't reached it yet on load.
          var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          this.classList.toggle('is-visible', scrolledPast);
          this.toggleAttribute('hidden', !scrolledPast);
        }

        onSubmitClick(event) {
          event.preventDefault();
          var form = getMainProductForm();
          if (form && typeof form.requestSubmit === 'function') {
            form.requestSubmit();
          } else if (form) {
            form.submit();
          }
        }
      }
    );
  }

  /* ------------------------------------------------------------------ *
   * Add-ons: checked add-ons ride along with the main add-to-cart submit
   * via a single /cart/add.js items[] call. Only intervenes when at least
   * one add-on checkbox is checked — otherwise Dawn's own product-form.js
   * handles the submit exactly as before.
   * ------------------------------------------------------------------ */
  function getCheckedAddons() {
    var boxes = document.querySelectorAll('.zknl-addon-row__checkbox');
    var checked = [];
    boxes.forEach(function (box) {
      if (box.checked && box.dataset.variantId) {
        checked.push({ id: parseInt(box.dataset.variantId, 10), quantity: 1 });
      }
    });
    return checked;
  }

  function addonsCartAddUrl() {
    var base = (window.routes && window.routes.cart_add_url) || '/cart/add';
    return base.replace(/\.js$/, '') + '.js';
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.matches || !form.matches(PRODUCT_FORM_SELECTOR)) return;
      if (form.dataset.zknlBypassAddons === 'true') {
        delete form.dataset.zknlBypassAddons;
        return;
      }

      var addons = getCheckedAddons();
      if (addons.length === 0) return; // let Dawn's own handler run untouched

      // Re-entrancy guard: a capture-phase stopPropagation() below prevents
      // Dawn's product-form.js from ever seeing this submit, so it never
      // gets the chance to disable the button itself. Without this guard a
      // double-click (or a second Enter keypress before the fetch resolves)
      // fires two parallel /cart/add.js calls that each add the product +
      // add-ons. If a request is already in flight, swallow the resubmit
      // entirely instead of letting it fall through to a real submission.
      if (form.dataset.zknlAddonsPending === 'true') {
        event.preventDefault();
        event.stopPropagation();
        return;
      }
      form.dataset.zknlAddonsPending = 'true';

      var submitButtons = form.querySelectorAll('[type="submit"]');
      submitButtons.forEach(function (btn) {
        btn.disabled = true;
      });

      function releasePending() {
        delete form.dataset.zknlAddonsPending;
        submitButtons.forEach(function (btn) {
          btn.disabled = false;
        });
      }

      event.preventDefault();
      event.stopPropagation();

      var formData = new FormData(form);
      var items = [
        {
          id: parseInt(formData.get('id'), 10),
          quantity: parseInt(formData.get('quantity'), 10) || 1,
        },
      ].concat(addons);

      fetch(addonsCartAddUrl(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items }),
      })
        .then(function (response) {
          if (!response.ok) throw new Error('cart add failed');
          return response.json();
        })
        .then(function () {
          releasePending();
          var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
          window.location.href = cartUrl;
        })
        .catch(function () {
          releasePending();
          // Graceful degradation: submit the main product only, the normal
          // Dawn way, so the customer isn't stuck when the add-ons call fails.
          form.dataset.zknlBypassAddons = 'true';
          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit();
          } else {
            form.submit();
          }
        });
    },
    true
  );
})();
